import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Layout from '@common/layout';
import { useLogout, useUserInfo } from '@repository/auth/useUserInfo';

const JobflexLogoutPage = () => {
  const router = useRouter();
  const { query } = router;
  const { messageUrl } = query;
  const { data: userInfo } = useUserInfo();
  const { mutateAsync: logout } = useLogout();
  const isLogin = !!userInfo?.id;

  const handleLogout = async () => {
    if (!window || !window.opener) return;
    await logout();
    window.opener.postMessage({ isJobdaLogout: true }, messageUrl as string);
  };

  useEffect(() => {
    if (isLogin) handleLogout();
  }, [isLogin]);

  return <Layout />;
};

export default JobflexLogoutPage;
